<template>
  <v-dialog v-model="showModal" width="400" @click:outside=closeDialog>
      <v-card max-width="400">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-h5 text-medium-emphasis ps-2 title-text" >add category</div>
          <v-btn icon="mdi-close" variant="text" @click=closeDialog></v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-sheet class="mx-auto" width="300">
            <v-form @submit.prevent ref="form">
              <v-text-field v-model="ticker" id="ticker" :rules="[required]" label="ticker" variant="underlined" class="form_field"></v-text-field>
              <v-select
                label="select broad"
                :items="broads"
                item-title="name"
                item-value="id"
                v-model="selectedBroad"
                :rules="[required]"
              ></v-select>
              <v-select
                label="select type"
                :items="types"
                item-title="name"
                item-value="id"
                v-model="selectedType"
                :rules="[required]"
              ></v-select>
              <v-select
                label="select country"
                :items="countries"
                item-title="name"
                item-value="id"
                v-model="selectedCountry"
                :rules="[required]"
              ></v-select>
            </v-form>
          </v-sheet>
        </v-card-text>
        <template v-slot:actions>
          <v-btn v-on:click="submitForm" class="mt-2 submit_button" type="submit" block>Submit</v-btn>
        </template>
      </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';

export default {
  props: {
    show: Boolean
  },
  data() {
    return {
      ticker: null,
      broads: [],
      types: [],
      countries: [],
      selectedBroad: null,
      selectedType: null,
      selectedCountry: null,
    }
  },
  async created() {
    this.getBroads();
    this.getTypes();
    this.getCountries();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
      get () {
        return this.show
      }
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]), 
    async submitForm(e) {
      e.preventDefault();
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      try {
        
        await axios.request({
          url: "/securities/categorisations/",
          method: "POST",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data: {
            ticker: this.ticker,
            broad_id: this.selectedBroad,
            type_id: this.selectedType,
            country_id: this.selectedCountry
          }
        });
          this.resetDataValues(); // clear form field values
          this.$parent.updatePageData();
          // this.$parent.getCategories(); // update list on local view
          // this.$parent.findUncategorisedSecurities(); // update list on local view *** this is not working.
          this.$emit("close"); // close modal via parent
      } catch (error) {
        this.showSnackbar({ message: 'Failed to create security categorisation' });
      }
    },
    async getBroads(){
      try {
      const response  = await axios.get("/securities/categorisations/config/broads",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.broads = response.data;
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load broad categories' });
      }
    },
    async getTypes(){
      try {
      const response  = await axios.get("/securities/categorisations/config/types",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.types = response.data;
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load security types' });
      }
    },
    async getCountries(){
      try {
      const response  = await axios.get("/securities/categorisations/config/countries",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.countries = response.data;
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load countries' });
      }
    },
    resetDataValues(){
      this.ticker = "";
      this.selectedBroad = "";
      this.selectedCountry = "";
      this.selectedType = "";
    },
    closeDialog(){
      this.resetDataValues();
      this.$emit('close');
    },
    required (v) {
        return (v !== null && v !== undefined && v !== '') || 'required'
    },
  } 
}
</script>

<style scoped>

.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>